import {AnamnesisQuestion, TextField} from '@legit.health/ui';
import {Box, Typography} from '@mui/material';
import {TFunction} from 'i18next';
import {UseFormReturn} from 'react-hook-form';
import StepTitle from '@/components/StepTitle';
import FormValues from '../../interfaces/FormValues';

export default function AnamnesisGeneralField({
  anamnesisQuestions,
  form,
  t
}: {
  anamnesisQuestions: AnamnesisQuestion[];
  form: UseFormReturn<FormValues>;
  t: TFunction;
}) {
  return (
    <Box mb={4} data-testid="anamnesisQuestionsContainer">
      <StepTitle
        title={t('app:anamnesisQuestions.title')}
        subtitle={t('app:anamnesisQuestions.subtitle')}
      />
      <Box mb={2}>
        {anamnesisQuestions.map((anamnesisQuestion, key) => (
          <Box key={`anamnesis-question--${anamnesisQuestion.code}`} mt={key === 0 ? 0 : 2}>
            <Typography
              sx={{
                mb: 0.5,
                lineHeight: 1.5
              }}
              variant="body2"
            >
              {anamnesisQuestion.question}
            </Typography>
            <TextField
              id={`${anamnesisQuestion.id}`}
              data-testid={`anamnesisQuestion-${anamnesisQuestion.code}`}
              type="text"
              fullWidth
              multiline
              {...form.register(`anamnesisQuestions.${anamnesisQuestion.id}`)}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
}
